import React from 'react'
import { connect } from 'react-redux'
import { fetchUser } from '../../actions/user-actions'
import { Grid, Row, Col, Table } from 'react-bootstrap'
import { isEmpty, flatMap } from 'lodash'

import Breadcrumbs from '../../components/Breadcrumbs'
import SearchBar from '../../components/SearchBar'
import Property from '../../components/Property'
import NotesOverview from '../../components/NotesOverview'
import PropertyTitle from '../../components/PropertyTitle'
import LicenseTable from '../../components/LicenseTable'
import NotFound from '../NotFound'

class UserDetail extends React.Component {
  componentDidMount() {
    this.props.fetchUser(this.props.match.params.id, this.props.history)
  }

  componentDidUpdate(oldProps) {
    if (this.props.match.params.id !== oldProps.match.params.id) {
      this.props.fetchUser(this.props.match.params.id, this.props.history)
    }
  }
  search(query) {
    this.props.history.push(`/gebruikers?query=${query}`)
  }

  render() {
    const { user } = this.props

    if (user && user.id === -1) {
      return <NotFound />
    }

    if (isEmpty(user) || user.id !== parseInt(this.props.match.params.id, 10)) {
      return null
    }

    var fullName = null
    if (!user.firstName && !user.lastName) {
      fullName = user.userId
    } else if (!user.firstName) {
      fullName = user.lastName
    } else if (!user.lastName) {
      fullName = user.firstName
    } else {
      fullName = `${user.firstName} ${user.lastName}`
    }

    let groups = flatMap(user.memberships, (m) => m.group)
    let customers = flatMap(groups, (g) => g.customer)

    return (
      <Grid>
        <Breadcrumbs title={fullName} />
        <SearchBar placeholder="Zoek op naam of email" callback={(query) => this.search(query)} />

        <Row>
          <div className="content">
            <Row>
              <Col xs={12}>
                <span className="title">
                  <b>Gebruiker</b>
                </span>
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <PropertyTitle icon="user" text={fullName} />
                <Property
                  icon="envelope-o"
                  tooltipText="Emailadres"
                  value={user.email}
                  entityId={user.id}
                  entity="user"
                  property="email"
                />
                <Property icon="user" tooltipText="User ID" value={user.userId} />
                <Property icon="database" value={user.identityProvider && user.identityProvider.name} />
              </Col>
            </Row>
            <Row className="second">
              <Col xs={12}>
                <LicenseTable showGroups licenses={user.licenses} history={this.props.history} />
                <div>
                  <PropertyTitle small icon="building-o" text="Klanten" />
                  <div className="tablescontainer">
                    {customers.length > 0 ? (
                      <Table striped>
                        <thead>
                          <tr>
                            <th>Naam</th>
                          </tr>
                        </thead>
                        <tbody>
                          {customers.map((customer) => (
                            <tr
                              className="customer"
                              key={customer.id}
                              onClick={() => this.props.history.push(`/klanten/${customer.id}`)}
                            >
                              <td>{customer.name}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    ) : (
                      <p>De gebruiker heeft geen klanten</p>
                    )}
                  </div>
                </div>
                <div>
                  <PropertyTitle small icon="users" text="Groepen" />
                  <div className="tablescontainer">
                    {groups.length > 0 ? (
                      <Table striped>
                        <thead>
                          <tr>
                            <th>Naam</th>
                            <th>Aantal Licenties</th>
                            <th>Klant</th>
                          </tr>
                        </thead>
                        <tbody>
                          {groups.map((group, index) => (
                            <tr
                              className="group"
                              key={index}
                              onClick={() => this.props.history.push(`/groepen/${group.id}`)}
                            >
                              <td>{group.name}</td>
                              <td>{group.licensesCount}</td>
                              <td>{group.customer.name}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    ) : (
                      <p>De gebruiker heeft geen groepen</p>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <NotesOverview user={user} />
          </div>
        </Row>
      </Grid>
    )
  }
}

export default connect(
  (state) => {
    return { user: state.users.detail }
  },
  {
    fetchUser,
  }
)(UserDetail)
